import moment from 'moment';
import utilsApi from 'utils/api/posts/UtilsApi';

/**
 * This method generates the provider permalink
 * @param {JSON} values Current flight form values
 * @param {string} departureIata Departure iata name
 * @param {boolean} isRound Is round trip?
 */
const CreateProviderPermalink = async (values, departureIata, isRound, token) => {
  const data = {
    offer_type: 'simple',
    provider: values.provider,
    departure: departureIata,
    departure_date: moment(values.departure_date).toISOString(),
    destination: values.arrival_iata,
    promo_code: values.promo_code,
  };
  if (isRound) {
    data.arrival_date = moment(values.arrival_date).toISOString();
  }
  const result = await utilsApi.providerPermalink(data, token);
  return result;
};

export default CreateProviderPermalink;
